import React from "react";
import style from "./Spinner.module.css";

const Spinner: React.FC = () => (
    <div className={style.loader}>

    </div>
);
export default Spinner;
